import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import { layoutModeTypes } from "../constants/layout";
//import images
import avatar1 from "../../assets/images/users/user-dummy-img.jpg";
import { roleBasedNavigationMenu } from "../../store/navigationMenu/action";
import { getShortcutAppsList } from "../../store/shortcutApps/action";
import FullScreenDropdown from "./FullScreenDropdown";

import { changeLayoutMode } from "../../store/layouts/action";

import { setToggleRightSideBar } from "../../store/rightSidebar/action";
import SelectCompany from "../popUpComponents/SelectCompany/SelectCompany";
import HandleDateTimeLeft from "./HandleDateTimeLeft";
import ManageSubscription from "../popUpComponents/manageSubscription/manageSubscription";
import { Link, useHistory } from "react-router-dom";
import { isEmpty } from "lodash";
import { showHelpIconsSuccess } from "../../store/scribe/action";
import HandleDateTimeLeftTrial from "./HandleTimeLeftTrial";
import { BillingTabGateAccessRequired } from "../../common/gateAccess";
import AccessLevelProtectedContent from "./accessLevelProtectedContent";
import LeaveRequest from "../popUpComponents/LeaveRequest/leaveRequest";
import { isSettingsEntryVisible } from "../../pages/Settings/settingsNavDataCompany";

const ProfileDropdown = () => {
  const history = useHistory();
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const updateWidth = () => {
      setScreenWidth(window.innerWidth);
    };
    window.addEventListener("resize", updateWidth);
    return () => window.removeEventListener("resize", updateWidth);
  }, []);
  const { showHelpIconsAPI } = useSelector((state) => ({
    showHelpIconsAPI: state.Scribe.showHelpIcons,
  }));
  const dispatch = useDispatch();

  // Change #100697 - DisplayName is often blank (invited/imported users), which
  // left the menu saying "Welcome User!". Fall back to the full name from the
  // same login payload.
  const authUserFromStorage = JSON.parse(localStorage.getItem("authUser"));
  const userDataFromStorage =
    authUserFromStorage?.data?.DisplayName?.trim() ||
    [
      authUserFromStorage?.get_user_data?.User_UserFirstName,
      authUserFromStorage?.get_user_data?.User_UserLastName,
    ]
      .filter((part) => part && String(part).trim())
      .join(" ") ||
    undefined;
  const localCompanyData = JSON.parse(
    localStorage.getItem("authUser")
  )?.get_company_data;

  const subscriptionFreeTrialEndDate =
    localCompanyData?.Company_SubscriptionFreeTrialEndDate;
  const Company_FlagLicenceAdded = localCompanyData?.Company_FlagLicenceAdded;

  const handleSubscriptionStatus = () => {
    // if subscriptionFreeTrial_Id NULL and subscriptionFreeTrialEndDate < today then return "Upgrade Required"
    // if subscriptionFreeTrial_Id NULL and subscriptionFreeTrialEndDate > today then return "Free Trial xx days left"
    if (!subscriptionFreeTrialEndDate) return;
    if (Company_FlagLicenceAdded === "1") return;
    if (!subscriptionFreeTrialEndDate > new Date()) {
      return (
        <DropdownItem>
          <i className="fa-regular fa-circle-xmark text-muted fs-16 align-middle me-1"></i>{" "}
          <span className="align-middle">Upgrade Required</span>
        </DropdownItem>
      );
    } else {
      return (
        <DropdownItem>
          <div className={"d-flex flex-row align-items-center"}>
            {" "}
            <i className="fa-regular fa-clock text-muted fs-16 align-middle me-1"></i>{" "}
            {HandleDateTimeLeftTrial(subscriptionFreeTrialEndDate)}
          </div>
        </DropdownItem>
      );
    }
  };

  const [userName, setUserName] = useState("Admin");
  const LSUser = JSON.parse(localStorage.getItem("authUser"))?.data;
  const LSUserProfileImage = JSON.parse(localStorage.getItem("authUser"))
    ?.get_user_data?.User_ImageUrl;
  const LSUserProfileTitle = JSON.parse(localStorage.getItem("authUser"))
    ?.get_user_data?.User_Title;

  //Dropdown Toggle
  const [isProfileDropdown, setIsProfileDropdown] = useState(false);
  const toggleProfileDropdown = () => {
    setIsProfileDropdown(!isProfileDropdown);
  };

  useEffect(() => {}, [isProfileDropdown]);
  const handleRole = (role) => {
    dispatch(roleBasedNavigationMenu(role));
  };
  const { layoutModeType } = useSelector((state) => ({
    layoutModeType: state.Layout.layoutModeType,
  }));
  const onChangeLayoutMode = (value) => {
    if (changeLayoutMode) {
      dispatch(changeLayoutMode(value));
    }
  };
  const mode =
    layoutModeType === layoutModeTypes["DARKMODE"]
      ? layoutModeTypes["LIGHTMODE"]
      : layoutModeTypes["DARKMODE"];

  // handdle open right side bar
  const openRightSideBar = () => {
    dispatch(setToggleRightSideBar(true));
  };
  // Modal Select Company PoUp - Start
  const [modalSelectCompany, setModalSelectCompany] = useState(false);
  const toggleSelectCompany = () => {
    setModalSelectCompany(!modalSelectCompany);
  };

  // Modal Select Company PoUp - End
  const [modalManageSubscription, setModalManageSubscription] = useState(false);

  const toggleManageSubscription = () => {
    setModalManageSubscription(!modalManageSubscription);
  };
  const [isEdit, setIsEdit] = useState(false);
  const { shortcutAppsList } = useSelector((state) => ({
    shortcutAppsList: state.ShortcutApps.shortcutAppsList?.shortcutquick_list,
  }));

  useEffect(() => {
    dispatch(getShortcutAppsList());
  }, []);
  const { userOnlineStatus } = useSelector((state) => ({
    userOnlineStatus: state.Login.userOnlineStatus,
  }));

  return (
    <React.Fragment>
      {modalManageSubscription && (
        <ManageSubscription
          modalManageSubscription={modalManageSubscription}
          setModalManageSubscription={setModalManageSubscription}
          toggleManageSubscription={toggleManageSubscription}
          isEdit={isEdit}
        />
      )}
      {modalSelectCompany && (
        <SelectCompany
          modalSelectCompany={modalSelectCompany}
          setModalSelectCompany={setModalSelectCompany}
          toggleSelectCompany={toggleSelectCompany}
        />
      )}

      <Dropdown
        isOpen={isProfileDropdown}
        toggle={toggleProfileDropdown}
        className="ms-sm-3 header-item topbar-user"
      >
        <DropdownToggle tag="button" type="button" className="btn">
          <div>
            <span className="d-flex align-items-center">
              <span>
                <img
                  title={userOnlineStatus ? "Online" : "Offline"}
                  className="rounded-circle header-profile-user"
                  style={
                    userOnlineStatus
                      ? { border: "2px solid #13C56B", padding: "2px" }
                      : { border: "2px solid #F46A6A", padding: "2px" }
                  }
                  src={LSUserProfileImage || avatar1}
                  alt={userDataFromStorage ?? "User"}
                />
              </span>

              <span className="text-start ms-xl-2">
                {/* Change #100697 - the name lives in the dropdown's
                    "Welcome X!" line only, not beside the avatar. */}
                <span className="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text">
                  {LSUserProfileTitle || " "}
                </span>
              </span>
            </span>
          </div>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          {/* Change #100697 - the signed-in name, styled like the items below
              and opening the profile, the same as the Profile item. */}
          <DropdownItem onClick={() => history.push("/settings/2/0")}>
            <i className="mdi mdi-account-outline text-muted fs-16 align-middle me-1"></i>{" "}
            <span className="align-middle">{userDataFromStorage || "User"}</span>
          </DropdownItem>
          <DropdownItem divider />
          <div
            title={"Click to manage subscription"}
            onClick={() => {
              history.push("/settings/1/18");
            }}
          >
            {handleSubscriptionStatus()}
          </div>
          <DropdownItem
            onClick={() => {
              setModalSelectCompany(true);
            }}
          >
            <i className="fa-solid fa-users-rectangle text-muted fs-14 align-middle me-1"></i>
            <span className="align-middle">Switch Company</span>
          </DropdownItem>
          <span
            onClick={() => {
              history.push("/settings/2/0");
            }}
          >
            <DropdownItem>
              <i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>
              <span className="align-middle">Profile</span>
            </DropdownItem>
          </span>
          <DropdownItem href="/faqs-crm-it">
            <i className="mdi mdi-lifebuoy text-muted fs-16 align-middle me-1"></i>{" "}
            <span className="align-middle">Help</span>
          </DropdownItem>
          <DropdownItem href="/guided-onboarding">
            <i className="ri-rocket-line text-primary fs-16 align-middle me-1"></i>{" "}
            <span className="align-middle fw-semibold text-primary">Setup Guide</span>
          </DropdownItem>
          {LSUser?.role === "dev" ? (
            <>
              <DropdownItem>
                <i className="mdi mdi-lifebuoy text-muted fs-16 align-middle me-1"></i>{" "}
                <span
                  className="align-middle"
                  onClick={() => handleRole("localMenu")}
                >
                  Menu: localMenu
                </span>
              </DropdownItem>
              <DropdownItem>
                <i className="mdi mdi-lifebuoy text-muted fs-16 align-middle me-1"></i>{" "}
                <span
                  className="align-middle"
                  onClick={() => handleRole("developer")}
                >
                  Menu: ApiMenu
                </span>
              </DropdownItem>
            </>
          ) : null}{" "}
          <AccessLevelProtectedContent
            accessLevel={BillingTabGateAccessRequired}
          >
            <Link to={`/settings/4/1`}>
              <DropdownItem>
                {/*<span className="badge bg-soft-success text-success mt-1 float-end">*/}
                {/*  New*/}
                {/*</span>*/}
                <i className="fa-solid fa-coins text-muted fs-16 align-middle me-1"></i>{" "}
                <span className="align-middle">Billing</span>
              </DropdownItem>{" "}
            </Link>
          </AccessLevelProtectedContent>
          {/* /referral-hub/home/view */}
          <Link to={`/referral-hub/home/view`}>
            <DropdownItem>
              {/*<span className="badge bg-soft-success text-success mt-1 float-end">*/}
              {/*  New*/}
              {/*</span>*/}
              <i className="fa-solid fa-user-group text-muted fs-16 align-middle me-1"></i>{" "}
              <span className="align-middle">Referrals</span>
            </DropdownItem>{" "}
          </Link>
          <Link to={`/settings`}>
            <DropdownItem>
              {/*<span className="badge bg-soft-success text-success mt-1 float-end">*/}
              {/*  New*/}
              {/*</span>*/}
              <i className="mdi mdi-cog-outline text-muted fs-16 align-middle me-1"></i>{" "}
              <span className="align-middle">Settings</span>
            </DropdownItem>{" "}
          </Link>
          {/* Task 24761 - straight to Super Admin. Gated with the SAME two
              checks the Settings page itself applies (developer flag, plus
              the administrator-100 floor from 24693) and through the same
              helper, so the shortcut cannot offer a door that bounces you
              back to User Profile. It is a shortcut, not a new door. */}
          {isSettingsEntryVisible({ gate: "developer" }) &&
            isSettingsEntryVisible({ gate: "administrator100" }) && (
            <Link to={`/settings/3/0`}>
              <DropdownItem>
                <i className="fa-regular fa-star text-muted fs-16 align-middle me-1"></i>{" "}
                <span className="align-middle">Super Admin</span>
              </DropdownItem>
            </Link>
          )}
          <DropdownItem divider />
          {screenWidth > 768 ? (
            <DropdownItem>
              <div
                className={"d-flex align-items-center justify-content-start"}
              >
                <FullScreenDropdown />
              </div>
            </DropdownItem>
          ) : null}
          {/*<DropdownItem onClick={() => onChangeLayoutMode(mode)}>*/}
          {/*  <div className={"d-flex align-items-center justify-content-start"}>*/}
          {/*    <i className="bx bx-moon text-muted fs-16 align-middle me-1"></i>*/}
          {/*    <span className="align-middle">Light/Dark Mode</span>*/}
          {/*  </div>*/}
          {/*</DropdownItem>*/}
          {/*<DropdownItem onClick={openRightSideBar}>*/}
          {/*  <div className={"d-flex align-items-center justify-content-start"}>*/}
          {/*    <i className="mdi  mdi-cog-outline fs-16 me-1"></i>*/}
          {/*    <span className="align-middle"> Choose Theme</span>*/}
          {/*  </div>*/}
          {/*</DropdownItem>*/}
          <DropdownItem
            onClick={() => {
              dispatch(showHelpIconsSuccess(!showHelpIconsAPI));
            }}
          >
            <div className={"d-flex align-items-center justify-content-start"}>
              <i className="fa-regular fa-circle-question fs-16 me-1"></i>
              <span className="align-middle">
                {showHelpIconsAPI ? "Hide" : "Show"} Helper Icons
              </span>
            </div>
          </DropdownItem>
          {/*{!isEmpty(shortcutAppsList) && (*/}
          {/*  <>*/}
          {/*    <DropdownItem divider />*/}
          {/*    {shortcutAppsList?.map((item, index) => {*/}
          {/*      return (*/}
          {/*        <DropdownItem key={index}>*/}
          {/*          /!*<a*!/*/}
          {/*          /!*  href={item?.LinkUrl || "/#"}*!/*/}
          {/*          /!*  className="dropdown-icon-item"*!/*/}
          {/*          /!*  // open new tab*!/*/}
          {/*          /!*  target="_blank"*!/*/}
          {/*          /!*>*!/*/}
          {/*          /!*  <img src={item?.ImageUrl} alt={item?.Title} />*!/*/}
          {/*          /!*  <span>{item?.Title}</span>*!/*/}
          {/*          /!*</a>*!/*/}
          {/*          <div*/}
          {/*            className={*/}
          {/*              "d-flex align-items-center justify-content-start"*/}
          {/*            }*/}
          {/*          >*/}
          {/*            <i*/}
          {/*              className={*/}
          {/*                item.icon*/}
          {/*                  ? item.icon + " fs-16 me-1"*/}
          {/*                  : "mdi mdi-clipboard-text-outline fs-16 me-1"*/}
          {/*              }*/}
          {/*            ></i>*/}
          {/*            <span className="align-middle"> {item?.Title}</span>*/}
          {/*          </div>*/}
          {/*        </DropdownItem>*/}
          {/*      );*/}
          {/*    })}*/}
          {/*  </>*/}
          {/*)}*/}
          <DropdownItem divider />
          <DropdownItem href="/logout">
            <i className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>{" "}
            <span className="align-middle" data-key="t-logout">
              Logout
            </span>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

export default ProfileDropdown;
